/**
* reducers for the fund
*
* Created by Min on 16/08/18
*/

import C from '../constants'

const initState = {
    docSignStatus : '',
    docSignLoading: false,
    documents : {},
    documentsloading : false,
}

export const documentsState = (state = initState, action) => {

    switch(action.type) {

        case C.SET_DOC_SIGN_STATUS:
            return {
                ...state,
                docSignStatus: action.payload
            }

        case C.SET_DOCUMNENTS_DATA:
            return {
                ...state,
                documents: getDocuments(action.payload)
            }

        case C.SET_DOCUMNENTS_LOADER:
            return {
                ...state,
                documentsloading: action.payload
            }

        case C.SET_DOCUMNENTS_FETCH_SUCCESS:
            return {
                ...state,
                fetchSuccess: action.payload
            }

        default: return state
    }
}

function getDocuments(data){
    // Need id and name of each doc
    const rawDocData = data['envelope_documents']
    let documents = []
    const doc1 = "SMSF Establishment Deed.pdf"
    const doc2 = "ATO Trustee declaration Form.pdf"
    rawDocData.forEach(
        (ele, index)=>{
            const document = { 'id':  ele['document_id'], 'name':  ele['name'] }
            documents.push(document)
        }
    )
    return documents
}



// WEBPACK FOOTER //
// ./src/reducers/documentsReducers.js